// extracted by mini-css-extract-plugin
module.exports = {"trustedRetailerBanner":"en-z","trustedRetailerTooltipWrapper":"fn-z"};